export const modalStyles = 'maps-expanded-modal transition-all duration-[400ms]'

export const closeIconButtonStyles =
   'p-3 rounded-full bg-[#fffc] backdrop-blur-sm cursor-pointer shadow-lg'

export const mobileCloseIconContainerStyles =
   'px-4 py-3 border-b border-gray-300'
